import React, { useState, useRef, useEffect } from 'react';

const ImageComparisonSlider = () => {
    const [sliderPosition, setSliderPosition] = useState(50);
    const [isDragging, setIsDragging] = useState(false);
    const containerRef = useRef(null);

    const handleMouseDown = () => {
        setIsDragging(true);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (isDragging && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const containerWidth = containerRect.width;
            const mouseX = e.clientX - containerRect.left;
            const newPosition = (mouseX / containerWidth) * 100;

            // 限制在0-100范围内
            const clampedPosition = Math.max(0, Math.min(100, newPosition));
            setSliderPosition(clampedPosition);
        }
    };

    const handleTouchMove = (e) => {
        if (containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const containerWidth = containerRect.width;
            const touch = e.touches[0];
            const touchX = touch.clientX - containerRect.left;
            const newPosition = (touchX / containerWidth) * 100;

            const clampedPosition = Math.max(0, Math.min(100, newPosition));
            setSliderPosition(clampedPosition);
        }
    };

    useEffect(() => {
        document.addEventListener('mouseup', handleMouseUp);
        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return (
        <>
            <div className="image-slider-container">
                <div
                    ref={containerRef}
                    className="slider-wrapper"
                    onMouseMove={handleMouseMove}
                    onTouchMove={handleTouchMove}
                >
                    {/* 左侧图片 */}
                    <div>
                        <img
                            src="/other/origin_img.jpg"
                            alt="左侧图片"
                            className="left-image"
                        />
                    </div>

                    {/* 右侧图片（被裁剪） */}
                    <div
                        className="right-image-container"
                        style={{ width: `${sliderPosition}%` }}
                    >
                        <img
                            src="/other/opt_img.jpg"
                            alt="右侧图片"
                            className="right-image"
                            style={{
                                width: `${100 / (sliderPosition / 100)}%`,
                                maxWidth: 'none'
                            }}
                        />
                    </div>

                    {/* 滑块控制条 */}
                    <div
                        className="slider-bar"
                        style={{ left: `${sliderPosition}%` }}
                        onMouseDown={handleMouseDown}
                        onTouchStart={handleMouseDown}
                    >
                        {/* 滑块把手 */}
                        <div className="slider-handle">
                            <div className="handle-bars">
                                <div className='h_left'></div>
                                <div className='h_right'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImageComparisonSlider;